export default __webpack_public_path__ + "static/media/apple-en.452d5edd.svg";